import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

import { TileDeleteButton } from "../common/TileDeleteButton";
import {
  VideoPreviewTile,
  VideoPreviewTileAction,
  VideoPreviewTileProps,
} from "../VideoPreviewTile/VideoPreviewTile";
import {
  classes as videoEffectTileOverlayClasses,
  VideoEffectTileOverlay,
} from "./components/VideoEffectTileOverlay";

export type VideoEffectTileAction = VideoPreviewTileAction | "DELETE";

interface VideoEffectTileProps extends VideoPreviewTileProps {
  title: string;
  isDeletable?: boolean;
  onAction?: (event: React.MouseEvent, action: VideoEffectTileAction) => void;
}

const Root = styled(Box)({
  fontSize: "1.2rem",
  position: "relative",
  [`& .${videoEffectTileOverlayClasses.root}`]: {
    opacity: 1,
  },
  "&:hover": {
    [`& .${videoEffectTileOverlayClasses.root}`]: {
      opacity: 0,
    },
  },
});

export const VideoEffectTile = (props: VideoEffectTileProps) => {
  const { title, isDeletable = false, onAction, ...rest } = props;

  const handleAction = (e: React.MouseEvent, action: VideoEffectTileAction) => {
    onAction?.(e, action);
  };

  return (
    <Root>
      <VideoPreviewTile
        shouldResetOnStop
        isLazyloaded
        shouldPlayOnHover
        slots={{
          topRightEl: undefined,
          bottomLeftEl: isDeletable ? TileDeleteButton : undefined,
        }}
        slotProps={{
          bottomLeftEl: {
            onAction,
            sx: {
              m: 1,
            },
          },
        }}
        onAction={handleAction}
        {...rest}
      />
      <VideoEffectTileOverlay title={title} />
    </Root>
  );
};
